import React from 'react';
import { Check, CreditCard } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="pricing" className="bg-gray-900 py-8 px-4 text-white" data-id="element-148">
      <div className="max-w-4xl mx-auto text-center" data-id="element-149">
        <div className="inline-block bg-red-600 text-white font-bold px-4 py-1 rounded-full mb-3 animate-pulse" data-id="element-150">
          🔥 OFERTA ESPECIAL POR TIEMPO LIMITADO
        </div>

        <h2 className="text-3xl md:text-5xl font-extrabold mb-4 leading-none" data-id="element-151">
          KIT COMPLETO
          <br className="md:hidden" data-id="element-152" /> PSICOLOGÍA LISTA
        </h2>

        <div className="bg-white text-gray-900 rounded-2xl p-6 md:p-8 max-w-3xl mx-auto shadow-2xl border-4 border-yellow-400 relative overflow-hidden" data-id="element-153">
          {/* Ribbon */}
          <div className="absolute top-3 right-3 bg-yellow-400 text-black font-extrabold px-3 py-1 rounded-md text-xs uppercase tracking-wide shadow-md" data-id="element-154">
            ⭐ Más Popular
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5 text-left" data-id="element-155">
            <div className="flex items-center gap-2" data-id="element-156">
              <Check className="w-6 h-6 text-green-600 flex-shrink-0" strokeWidth={3} data-id="element-157" />
              <span className="font-bold text-lg" data-id="element-158">Acceso de por vida</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-159">
              <Check className="w-6 h-6 text-green-600 flex-shrink-0" strokeWidth={3} data-id="element-160" />
              <span className="font-bold text-lg" data-id="element-161">Descarga inmediata</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-162">
              <Check className="w-6 h-6 text-green-600 flex-shrink-0" strokeWidth={3} data-id="element-163" />
              <span className="font-bold text-lg" data-id="element-164">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-165">
              <Check className="w-6 h-6 text-green-600 flex-shrink-0" strokeWidth={3} data-id="element-166" />
              <span className="font-bold text-lg" data-id="element-167">2 Bonos incluidos</span>
            </div>
          </div>

          <div className="mb-5" data-id="element-168">
            <p className="text-gray-500 text-lg mb-1" data-id="element-169">Precio regular</p>
            <div className="flex flex-col items-center gap-1" data-id="element-170">
              <span className="text-2xl md:text-3xl text-red-500 line-through font-bold decoration-2 decoration-red-500" data-id="element-171">
                $49.990 ARS
              </span>
              <span className="text-4xl md:text-6xl font-extrabold text-green-600" data-id="element-172">
                $19.990 ARS
              </span>
            </div>
            <p className="text-gray-600 mt-2 font-medium" data-id="element-173">
              Pago único · Pagarás en pesos argentinos
            </p>
          </div>

          <CTAButton href="https://checkout.kitonline.shop/cart/47657878585582:1" className="w-full text-xl md:text-2xl py-6 shadow-xl animate-pulse" data-id="element-174">
            👉 SÍ, QUIERO EL KIT COMPLETO
          </CTAButton>

          <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-175">
            <p className="text-sm text-gray-500 mb-2 font-medium" data-id="element-176">
              Métodos de pago seguros
            </p>
            <div className="flex flex-wrap justify-center items-center gap-4 text-gray-400 grayscale opacity-70" data-id="element-177">
              <span className="font-bold" data-id="element-178">MERCADO PAGO</span>
              <span className="font-bold" data-id="element-179">VISA</span>
              <span className="font-bold" data-id="element-180">MASTERCARD</span>
              <span className="font-bold" data-id="element-181">TRANSFERENCIA</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}